import script from "./ReceivedReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedReportPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/received.css?vue&type=style&index=0&id=25371df9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25371df9"]])

export default __exports__